import type { Components, Theme } from '@mui/material';
import { withDefault } from '@weft/utils';

export const MuiTabs: Components<Omit<Theme, 'components'>>['MuiTabs'] = {
  defaultProps: {
    indicatorColor: 'secondary',
  },
  styleOverrides: {
    indicator: ({ theme, ownerState }) => ({
      boxShadow: `0px -1px 5px 0px ${theme.palette[withDefault(ownerState.indicatorColor, 'secondary')].outlinedBorder}`,
    }),
    root: {
      minHeight: '42px',
      maxHeight: '42px',
      height: '42px',
    },
  },
};